// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:30
import { KeywordAddress_abstract } from './../../abstract/SagaBase/Objects/KeywordAddress_abstract';
export class KeywordAddress extends KeywordAddress_abstract {}
